// extracted by mini-css-extract-plugin
export default {"container":"rank_container__2GYnv","position":"rank_position__2eb3j","points":"rank_points__ZI_OV","defisTheme":"rank_defisTheme__3AIWl"};